export const rankingsConstants = {
  DETAIL_REQUEST: 'RANKINGS_DETAIL_REQUEST',
  DETAIL_SUCCESS: 'RANKINGS_DETAIL_SUCCESS',
  MONTHLY_DETAIL_SUCCESS: 'RANKINGS_MONTHLY_DETAIL_SUCCESS',
  DETAIL_FAILURE: 'RANKINGS_DETAIL_FAILURE'
};
